module.exports = new __parcel__URL__("inside-out-a-personal-history-of-pink-floyd.dfdd26c5.jpg").toString();